<template>
    <div class="user-general-info">
        <v-form>
            <v-row class="mx-0 pt-8">
                <v-col cols="12" class="col-sm-6 col-md-3">
                    <v-text-field v-model="baseUserData.firstName" label="Имя" color="teal" @change="dataChange"></v-text-field>
                </v-col>
                <v-col cols="12" class="col-sm-6 col-md-3">
                    <v-text-field v-model="baseUserData.lastName" label="Фамилия" color="teal" @change="dataChange"></v-text-field>
                </v-col>
                <v-col cols="12" class="col-sm-6 col-md-3">
                    <v-text-field v-model="baseUserData.userName" label="Учетная запись (имя)" color="teal" @change="dataChange"></v-text-field>
                </v-col>
                <v-col cols="12" class="col-sm-6 col-md-3">
                    <v-text-field v-model="baseUserData.createdAt" label="Дата регистрации" color="teal" @change="dataChange"></v-text-field>
                </v-col>
                <v-col cols="12" class="col-sm-6 col-md-3">
                    <v-text-field v-model="baseUserData.email" label="Регистрационный email" color="teal" @change="dataChange"></v-text-field>
                </v-col>
                <v-col cols="12" class="col-sm-6 col-md-3">
                    <v-text-field v-model="baseUserData.phone" label="Регистрационный номер телефона" color="teal" @change="dataChange"></v-text-field>
                </v-col>
                <v-col cols="12" class="col-sm-6 col-md-3">
                    <v-text-field v-model="baseUserData.phoneMain" label="Основной номер телефона" color="teal" @change="dataChange"></v-text-field>
                </v-col>
                <v-col cols="12" class="col-sm-6 col-md-3">
                    <v-text-field v-model="baseUserData.phoneAdd" label="Дополнительный номер телефона" color="teal" @change="dataChange"></v-text-field>
                </v-col>
                <v-col cols="12" class="pa-0">
                    <div class="spacer"></div>
                </v-col>
                <v-col cols="12" class="col-sm-6 col-md-3">
                    <v-switch v-model="baseUserData.isBuyer" label="Покупатель" color="teal" @change="dataChange"></v-switch>
                </v-col>
                <v-col cols="12" class="col-sm-6 col-md-3">
                    <v-switch v-model="baseUserData.isSeller" label="Продавец" color="teal" @change="dataChange"></v-switch>
                </v-col>
                <v-col cols="12" class="col-sm-6 col-md-3">
                    <v-switch v-model="baseUserData.isPhysical" label="Физ-лицо" color="teal" @change="dataChange"></v-switch>
                </v-col>
                <v-col cols="12" class="col-sm-6 col-md-3">
                    <v-switch v-model="baseUserData.isLaw" label="Юр-лицо" color="teal" @change="dataChange"></v-switch>
                </v-col>
                <v-col cols="12">
                    <v-textarea v-model="baseUserData.comment" label="Комментарий" color="teal" clearable @change="dataChange"></v-textarea>
                </v-col>
                <div class="spacer"></div>
                <v-col cols="12" class="text-center text-sm-right">
                    <v-btn text color="teal" @click="$emit('save')">Сохранить</v-btn>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
    import UserDataMixin from "./UserDataMixin"

    export default {
        name: "GeneralInfo",
        props: ['dataKey'],
        mixins: [UserDataMixin],
        methods: {
            dataChange() {
                this.$emit('update', this.getEmitData());
            },
            getEmitData() {
                return {
                    key: this.dataKey,
                    data: this.baseUserData
                }
            }
        },
    }
</script>

<style scoped>

</style>